import config from 'config';

export const redirectToPayPalVerification = () => {
  const PAYPAL_ENDPOINT =
    config.payPalEnv === 'SANDBOX' ? 'https://www.sandbox.paypal.com' : 'https://www.paypal.com';

  const RETURN_URL = encodeURIComponent(String(config.organizerUri));
  const LIST_OF_SCOPES = encodeURIComponent(
    'profile openid email address https://uri.paypal.com/services/paypalattributes https://uri.paypal.com/services/paypalattributes/business'
  );

  window.location.href = `${PAYPAL_ENDPOINT}/signin/authorize?flowEntry=static&client_id=${config.payPalClientId}&scope=${LIST_OF_SCOPES}&redirect_uri=${RETURN_URL}`;
};
